import React from 'react';

// types
import { HistoryEvent } from './types';

// Components
import HistoryEventsItem from './HistoryEventsItem';

// Styles
import './HistoryEvents.scss';

type Props = {
  events: HistoryEvent[];
};

const HistoryEvents = ({ events }: Props) => {
  const baseClassName = 'HistoryEvents';

  // filter out any events that are undefined
  const eventsToRender = events.filter(event => event);
  return (
    <div className={baseClassName}>
      {eventsToRender.map(event => (
        <HistoryEventsItem event={event} />
      ))}
    </div>
  );
};

export default HistoryEvents;
